export const site = {
  name: "Vakkundig Verhuizingen & Transport",
  shortName: "Vakkundig",
  tagline: "Verhuisbedrijf in Den Haag en heel Zuid-Holland",
  phone: "085 060 1023",
  phoneHref: "tel:+31850601023",
  whatsapp: "06 84566663",
  whatsappHref: "https://wa.me/31684566663",
  whatsappMessage:
    "https://wa.me/31684566663?text=Hallo%2C%20ik%20wil%20graag%20een%20offerte%20voor%20mijn%20verhuizing.",
  email: "info@vakkundig-verhuizingen-transport.nl",
  emailHref: "mailto:info@vakkundig-verhuizingen-transport.nl",
  address: {
    street: "Van Naeltwijckstraat 114A",
    postalCode: "2274 PD",
    city: "Voorburg",
    country: "NL",
  },
  hours: "Maandag t/m zondag, 09:00 – 18:00",
  kvk: "83435263",
  permit: "NIWO-vergunning voor beroepsgoederenvervoer",
  founded: "2020",
  url: "https://vakkundig-verhuizingen-transport.nl",
  social: {
    facebook: "https://www.facebook.com/share/1DUztyTayT/",
    instagram: "https://www.instagram.com/vakkundigverhuizingentransport",
    linkedin: "https://www.linkedin.com/company/vakkundig-verhuizingen-transport",
    tiktok: "https://www.tiktok.com/@vakkundig.verhuiz",
    google: "https://g.co/kgs/orQ3rC7",
  },
  /** Deelbare link waarmee klanten direct een Google-review achterlaten. */
  reviewUrl: "https://g.co/kgs/orQ3rC7",
} as const;

export const usps = [
  "Eén vast aanspreekpunt van eerste contact tot de laatste doos",
  "Ervaren verhuizers die rustig en zorgvuldig werken",
  "Duidelijke offerte op maat, geen verrassingen achteraf",
  "Compleet aanbod: verhuizen, inpakservice, opslag en ontruiming",
  "Zeven dagen per week bereikbaar, ook in het weekend verhuizen",
];

export const nav = [
  { to: "/", label: "Home" },
  { to: "/diensten", label: "Diensten" },
  { to: "/werkgebied", label: "Werkgebied" },
  { to: "/reviews", label: "Reviews" },
  { to: "/verhuistips", label: "Verhuistips" },
  { to: "/over-ons", label: "Over ons" },
  { to: "/contact", label: "Contact" },
] as const;
